<template>
  <div class="analytics-filter" :class="{'open' : open}">
    <slot name="toggle"></slot>
    <div class="analytics-filter-header">
      <slot name="header"></slot>
    </div>
    <div class="analytics-filter-body">
      <!--Saved Filters-->
      <div class="analytics-filter-options-block">
        <div class="dropdown-filter-primary analytics-filter-dropdown clearable">
          <v-autocomplete
            @change="getBySavedFilter($event)"
            @click:clear="getBySavedFilter($event, true)"
            :value="savedFilters.model"
            :items="savedFilters.items"
            :search-input.sync="savedFilter.search"
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon="close"
            attach
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="My Filters"
            solo
            flat
          >
            <template v-slot:item="{ item }">
              <v-list-tile-content>
                <v-list-tile-title v-text="item.name"></v-list-tile-title>
                <v-btn
                  class="ma-0 pa-0 btn-table-action"
                  color="error"
                  flat
                  small
                  :ripple="false"
                  @click="deleteSavedFilter($event, item.name)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </div>
      </div>
      <v-form ref="filtersForm">
        <!--Seller-->
        <div class="analytics-filter-options-block">
          <v-list>
            <v-list-group no-action class="d-block" v-model="active" @click="onClickSeller">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Sellers</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile>
                <i-text-field
                  v-model="sellerSearch"
                  solo
                  type="text"
                  placeholder="Search ..."
                  class="i-v-text-field-default"
                  @input="searchSeller($event)"
                />
                <div class="options-list mt-2">
                  <v-progress-circular
                    v-if="sellers.isLoading"
                    :size="75"
                    color="primary"
                    indeterminate
                    class="progress-circular"/>
                  <template>
                    <v-checkbox
                      v-for="item in sellerItems"
                      v-model="requests.sellers"
                      :value="item.id"
                      :label="item.name"
                      :key="item.id"
                      :ripple="false"
                      color="primary"
                      :class="`option-level-${item.level}`"
                      hide-details
                      @change="addToSeller(requests.sellers, item.id, $event)" />
                  </template>
                  <infinite-loading v-if="sellerItems.length >= limit" :identifier="infiniteId" @infinite="infiniteHandler">
                    <div slot="no-more">No more sellers</div>
                    <div slot="no-results">No more sellers</div>
                  </infinite-loading>
                </div>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </div>
        <!--Category-->
        <div class="analytics-filter-options-block">
          <v-list>
            <v-list-group no-action class="d-block">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Categories</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile>
                <i-text-field
                  v-model="categoriesSearch"
                  solo
                  type="text"
                  placeholder="Search ..."
                  class="i-v-text-field-default"
                  @input="searchCategory($event)"
                />
                <div class="options-list mt-2">
                  <div class="text-xs-center my-4" v-if="sellers.isLoading">
                    <v-progress-circular
                      :size="75"
                      color="primary"
                      indeterminate
                      class="progress-circular"/>
                  </div>
                  <div v-for="(item) in categories.items" :key="item.category.id" class="parent">
                    <label v-if="item.show" class="i-checkbox" :class="`option-level-${item.category.level}`">
                      <span class="i-checkbox-label">{{item.category.name}}</span>
                      <input type="checkbox" @change="addToCategories($event, item.category.id)" :id="item.category.id" ref="categoryCheckbox">
                      <span class="checkmark"></span>
                    </label>
                    <template v-if="Object.keys(item.children).length > 0">
                      <div v-for="(item2, index2) in item.children" :key="index2" class="parent">
                        <label v-if="item2.show" class="i-checkbox" :class="`option-level-${item2.category.level}`">
                          <span class="i-checkbox-label">{{item2.category.name}}</span>
                          <input type="checkbox" @change="addToCategories($event, item2.category.id)" :id="item2.category.id" ref="categoryCheckbox">
                          <span class="checkmark"></span>
                        </label>
                        <template v-if="Object.keys(item2.children).length > 0">
                          <div v-for="(item3, index3) in [].slice.call(Array(item2))" :key="index3">
                            <div v-for="(item4, index4) in item3.children" :key="index4" class="parent">
                              <label v-if="item3.show" class="i-checkbox" :class="`option-level-${item4.level}`">
                                <span class="i-checkbox-label">{{item4.name}}</span>
                                <input type="checkbox" @change="addToCategories($event, item4.id)" :id="item4.id" ref="categoryCheckbox">
                                <span class="checkmark"></span>
                              </label>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </div>
        <!--Brand-->
        <div class="analytics-filter-options-block">
          <v-list>
            <v-list-group no-action class="d-block">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Brands</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile>
                <i-text-field
                  v-model="brandSearch"
                  solo
                  type="text"
                  placeholder="Search ..."
                  class="i-v-text-field-default"
                  @input="searchBrand($event)"
                />
                <div class="options-list mt-2">
                  <v-progress-circular
                    v-if="brands.isLoading"
                    :size="75"
                    color="primary"
                    indeterminate
                    class="progress-circular"/>
                  <template v-if="!brandSearch">
                    <v-checkbox
                      v-for="item in brands.items"
                      v-model="brands.request"
                      :value="item.id"
                      :label="item.name"
                      :key="item.id"
                      :ripple="false"
                      color="primary"
                      :class="`option-level-${item.level}`"
                      hide-details
                      @change="addToBrands(brands.request, item.id)" />
                  </template>
                  <template v-if="brandSearch">
                    <v-checkbox
                      v-for="item in brands.searchItems"
                      @change="addToBrands($event, item.id)"
                      :input-value="false"
                      :label="item.name"
                      :key="item.id"
                      :ripple="false"
                      color="primary"
                      :class="`option-level-${item.level}`"
                      hide-details />
                  </template>
                </div>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </div>
      </v-form>
      <slot></slot>
    </div>
    <div class="analytics-filter-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import {mapState} from 'vuex'

export default {
  name: 'analyticsFilter',
  components: {
    InfiniteLoading
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Array, Object],
      default: null
    },
    savedFilters: {
      type: [Array, Object],
      default: null
    }
  },
  data: () => ({
    sellerSearch: null,
    categoriesSearch: null,
    brandSearch: null,
    savedFilter: {
      model: null,
      search: null
    },
    requests: {
      sellers: [],
      brands: []
    },
    sellerItems: [],
    infiniteId: +new Date(),
    active: false,
    page: 1,
    limit: 25,
    timer: null
  }),
  created () {
    this.categoriesWatcher = this.$store.watch(// Watching changes of Categories
      (state, _getters) => _getters['analyticsFilterSellerModule/categoriesGetter'].request,
      (_newValue, _oldValue) => {
        if (!_newValue.length) {
          for (let checkbox of this.$refs.categoryCheckbox) { // Reset Categories filter
            checkbox.checked = false
          }
        }
      }
    )
  },
  beforeDestroy () {
    this.categoriesWatcher()
  },
  methods: {
    infiniteHandler ($state) {
      const items = this.sellerSearch ? this.sellers.searchItems : this.sellers.items
      if ((this.page * this.limit) <= items.length) {
        this.sellerItems.push(...items.slice((this.page - 1) * this.limit, this.page * this.limit))
        this.page++
      }
      if ((this.page * this.limit) >= items.length) {
        $state.complete()
      } else {
        $state.loaded()
      }
    },
    onClickSeller () {
      if (!this.active) {
        this.sellerItems = this.sellers.items.slice(0, this.limit)
        this.page++
      }
    },
    addToSeller (items, id, event) {
      this.$store.dispatch('analyticsFilterSellerModule/requestFilterSellers', {
        id: id,
        items: items
      })
    },
    addToBrands (items, id) {
      this.$store.dispatch('analyticsFilterSellerModule/requestFilterBrands', {
        id: id,
        items: items
      })
    },
    addToCategories (e, id) {
      let target = e.target
      let parent = target.closest('.parent')
      let children = parent.querySelectorAll('input[type=checkbox]')
      if (target.checked === true) {
        children.forEach(item => {
          if (item.id === id) {
            item.checked = false
          }
          if (item.checked !== true) {
            item.checked = true
            this.$store.dispatch('analyticsFilterSellerModule/requestFilterCategories', {
              id: item.id,
              status: target.checked
            })
          }
        })
      } else {
        children.forEach(item => {
          if (item.id === id) {
            item.checked = true
          }
          if (item.checked === true) {
            item.checked = false
            this.$store.dispatch('analyticsFilterSellerModule/requestFilterCategories', {
              id: item.id,
              status: target.checked
            })
          }
        })
      }
    },
    searchSeller (e) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$store.commit('analyticsFilterSellerModule/SEARCH_sellers', e)
        this.$nextTick(() => {
          if (e && this.sellers.searchItems.length) {
            this.sellerItems = this.sellers.searchItems.slice(0, this.limit)
            this.page = 2
            this.infiniteId += 1
          } else if (!e) {
            this.sellerItems = this.sellers.items.slice(0, this.limit)
            this.page = 2
            this.infiniteId += 1
          }
        })
      }, 500)
    },
    searchBrand (e) {
      this.$store.commit('analyticsFilterSellerModule/SEARCH_brands', e)
    },
    searchCategory (e) {
      this.$store.commit('analyticsFilterSellerModule/SEARCH_categories', e)
    },
    setSavedFilterModels () {
      for (let key in this.requests) {
        this.requests[key] = this.getAllFilters[key].request
      }
    },
    getBySavedFilter (e, isNull) {
      if (isNull) {
        this.$store.dispatch('analyticsFilterSellerModule/getBySavedFilter', []).then(() => {
          this.$emit('savedFilterSelected')
        })
      } else {
        // Reset checkboxes
        for (let checkbox of this.$refs.categoryCheckbox) {
          checkbox.checked = false
        }
        this.$refs.filtersForm.reset()
        this.$store.dispatch('analyticsFilterSellerModule/getBySavedFilter', e).then(() => {
          this.setSavedFilterModels()
          for (let checkbox of this.$refs.categoryCheckbox) {
            if (this.getFilterCategoriesREQ.includes(checkbox.id)) {
              checkbox.checked = true
            }
          }
          this.$emit('savedFilterSelected')
        })
      }
    },
    deleteSavedFilter (e, name) {
      e.stopPropagation()
      this.$emit('deleteSavedFilter', name)
    }
  },
  computed: {
    ...mapState({
      sellers: state => state.analyticsFilterSellerModule.sellers,
      categories: state => state.analyticsFilterSellerModule.categories,
      brands: state => state.analyticsFilterSellerModule.brands
    }),
    getFilterSellersREQ: {
      get () {
        return this.$store.state.analyticsFilterSellerModule.sellers.request
      },
      set (value) {
        // console.log(value)
        // this.$store.commit('updateMessage', value)
      }
    },
    getAllFilters () {
      return this.$store.state.analyticsFilterSellerModule
    },
    getFilterCategoriesREQ () {
      return this.$store.state.analyticsFilterSellerModule.categories.request
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/filter.vue